<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowContactsWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowContactsWidget/FlowContactsWidget.vue')
  )
  const FlowContactsWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowContactsWidgetQC/FlowContactsWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  useApiRequestsAbort()

  const isContactsQcEnabled = computed(() => featuresStore.isContactsQcEnabled)
</script>

<template>
  <FlowContactsWidgetQC v-if="isContactsQcEnabled" />
  <FlowContactsWidget v-else />
</template>
